export enum TaxCodesTabsEnum {
  SALES = 'sales',
  PURCHASES = 'purchases',
}
